<template>
  <div class="my-property-component">
    <div class="property-info-wrap">
      <div class="balance-info">
        <div class="title">团队余额</div>
        <div class="balance-num">￥{{ team.balance || 0 }}</div>
        <div class="btn-list">
          <router-link class="btn flex-cc" :to="{ path: '/recharge/team' }">充值</router-link>
          <router-link class="btn flex-cc" :to="{ path: '/balance/team' }">详情</router-link>
        </div>
      </div>
      <div class="balance-info credit-deposit">
        <div class="title">团队信用金</div>
        <div class="balance-num">￥{{ team.credit_deposit || 0.00 }}</div>
        <div class="btn-list">
          <router-link class="btn flex-cc" :to="{ path: '/credit_deposit/team' }">详情</router-link>
        </div>
      </div>
    </div>
    <div class="order-card">
      <div class="order-tab">
        <div class="tabs">
          <div @click="changeTab('member')" :class="['item', { 'active': active == 'member' }]">团队成员<span class="num">{{
          member || 0 }}</span></div>
          <div @click="changeTab('order')" :class="['item', { 'active': active == 'order' }]">
            待还款订单<span class="num">{{
          order || 0 }}</span></div>
        </div>

      </div>
      <div class="table-wrap">
        <template v-if="active == 'member'">
          <el-table :data="memberList" ref="myTable" v-loading="loading" element-loading-text="给我一点时间"
            :empty-text="emptyText" border>
            <el-table-column label="编号" align="center" width="100" prop="id">
            </el-table-column>
            <el-table-column label="姓名" align="center" minWidth="150">
              <template slot-scope="{row}">
                <div>{{ row.name || '--' }}</div>
              </template>
            </el-table-column>
            <el-table-column label="角色" align="center" minWidth="100">
              <template slot-scope="{row}">
                <div>{{ row.team_role == 0 ? '团员' : row.team_role == 1 ? '管理员' : '团长' }}</div>
              </template>
            </el-table-column>
            <el-table-column label="手机号" align="center" minWidth="150" prop="phone">
            </el-table-column>
            <el-table-column label="入团时间" align="center" minWidth="200" prop="team_join_time">
            </el-table-column>
            <el-table-column label="操作" align="center" minWidth="100" fixed="right">
              <template slot-scope="{row}">
                <template v-if="row.team_role != 100">
                  <el-button type="text" v-if="user.team_role > 0" class="colorRed"
                    @click="handleDelete(row)">删除成员</el-button>
                  <el-button type="text" v-if="row.team_role == 0" class="colorBlue"
                    @click="handleSetAdmin(row)">设为管理员</el-button>
                  <el-button type="text" v-if="row.team_role == 1" class="colorGold"
                    @click="handleCancelAdmin(row)">取消管理员</el-button>
                </template>
              </template>
            </el-table-column>
          </el-table>
        </template>
        <template v-else>
          <el-button :disabled="checkList.length == 0" @click="handleMultiRepayment" class="my-btn">批量还款</el-button>
          <el-table class="xm-table" ref="myTable" :data="orderList" v-loading="loading" element-loading-text="给我一点时间"
            :empty-text="emptyText" fit highlight-current-row>
            <el-table-column label="订单信息" align="center" minWidth="400">
              <template slot="header" slot-scope="scope">
                <div class="flex-row">
                  <div class="flex-grow-0 mgl10">
                    <el-checkbox v-model="checkAll" @change="handleCheckAll">全选</el-checkbox>
                  </div>
                  <div class="flex-grow-1">订单信息</div>
                </div>
              </template>
              <template slot-scope="{row}">
                <div class="row01 flex-row">
                  <div class="flex-grow-0 mgl10">
                    <el-checkbox v-model="row.checked" @change="handleCheck(row)">
                    </el-checkbox>
                  </div>
                  <div class="flex-grow-1 mgl10 tal">订单号：{{ row.order_no }} </div>
                  <div class="flex-grow-0">时间：{{ row.create_time }}</div>
                </div>
                <div class="row002" :style="{ 'height': (row.product.length * tableRowHeight) + 'px' }">
                  <div class="flex-col goods" v-for="(goods, index) in row.product" :key="index">
                    <div class="flex-row mgt10 mgl10 tal">
                      <div class="flex-grow-0 mgr10">
                        <el-image style="width: 70px;height: 70px;" :src="goods.cover"></el-image>
                      </div>
                      <div class="flex-grow-1 flex-col">
                        <div class="name">
                          <span>{{ goods.name }}</span>
                        </div>
                        <div class="desc">
                          <span>×{{ goods.num }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="金额" align="center" width="120">
              <template slot-scope="{row}">
                <div class="row01">
                </div>
                <div class="row02 flex-xy-center flex-col"
                  :style="{ 'height': (row.product.length * tableRowHeight) + 'px' }">
                  <span>￥{{ row.pay_amount }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="状态" align="center" width="100">
              <template slot-scope="{row}">
                <div class="row01">
                </div>
                <div class="row02 flex-xy-center" :style="{ 'height': (row.product.length * tableRowHeight) + 'px' }">
                  <span style="color:#FF8F1F;">{{ row.status_name }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="备注" align="center" width="120">
              <template slot-scope="{row}">
                <div class="row01">
                </div>
                <div class="row02 flex-xy-center flex-col"
                  :style="{ 'height': (row.product.length * tableRowHeight) + 'px' }">
                  <span>{{ row.remark }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="100" fixed="right">
              <template slot-scope="{row}">
                <div class="row01">
                </div>
                <div class="row02 flex-xy-center flex-col"
                  :style="{ 'height': (row.product.length * tableRowHeight) + 'px' }">
                  <template v-if="row.repayment_pay_id == 0 && row.credit_deposit_amount > 0">
                    <el-link :underline="false" @click="handleRepayment(row)">去还款</el-link>
                  </template>
                  <el-link :underline="false" @click="handleDetail(row)">查看详情</el-link>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </template>
        <div class="flex-row mgt20">
          <div class="flex-grow-1"></div>
          <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="listQuery.page" :page-sizes="[10, 20, 30, 50]" :page-size="listQuery.pagesize"
            layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getIndex, getUserList, deleteUser, setAdmin, cancelAdmin, getOrderList, getStatCount } from "@/api/team";
import { getIndex as getUserIndex } from "@/api/user";
export default {
  name: 'TeamCenter',
  components: {

  },
  data() {
    return {
      loading: false,
      team: {},
      user: {},
      emptyText: '暂无数据',
      active: 'order',
      listQuery: {
        repayment_pay_id: null,
        page: 1,
        pagesize: 10
      },
      memberList: [],
      orderList: [],
      total: 0,
      member: 0,
      order: 0,
      tableRowHeight: 90,
      checkList: [],
      checkAll: false,
    };
  },
  computed: {

  },
  created() {
    this.active = this.$route.params.active || 'member';
    this.getUserIndex();
    this.getIndex();
    this.getStatCount();
    this.getList();
  },
  methods: {
    getUserIndex() {
      getUserIndex({}).then(res => {
        this.user = res.data.user;
      }).catch((err) => {

      });
    },
    getIndex() {
      getIndex({}).then(res => {
        this.loading = false;
        this.team = res.data;
      }).catch((err) => {

      });
    },

    handleCheckAll(val) {
      // console.log(val)
      this.orderList.forEach((item) => {
        item.checked = val;
      });
      this.handleCheck();
    },
    handleCheck() {
      this.checkList = this.orderList.filter((item) => {
        return item.checked;
      }).map((item) => {
        return item.id;
      });
      // console.log(this.checkList)
      if (this.checkList.length == this.list.length) {
        this.checkAll = true;
      } else {
        this.checkAll = false;
      }
    },
    changeTab(active) {
      this.active = active
      this.$router.push(
        {
          name: 'TeamCenter',
          params: { active: active }
        }
      )
    },
    getStatCount() {
      getStatCount({}).then((response) => {
        this.member = response.data.member * 1;
        this.order = response.data.order * 1
      }).catch(() => {
        this.loading = false;
      });
    },
    // 获取列表
    getList() {
      this.loading = true;
      const _listQuery = Object.assign({}, this.listQuery);
      if (this.active == 'order') {
        _listQuery.repayment_pay_id = 0
        getOrderList(_listQuery).then((response) => {
          this.orderList = response.data.list.map((item, index) => {
            item.checked = false;
            return item;
          });
          this.total = response.data.count * 1;
          this.loading = false;
        }).catch(() => {
          this.loading = false;
        });
      } else {
        getUserList(_listQuery).then((response) => {
          this.memberList = response.data.list;
          this.total = response.data.count * 1;
          this.loading = false;
        }).catch(() => {
          this.loading = false;
        });
      }

    },

    // 设为管理员
    handleSetAdmin(user) {
      this.$confirm('确定将此成员设为管理员吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        this.loading = true;
        setAdmin({
          id: user.id
        }).then((response) => {
          this.loading = false;
          this.getList();
          this.$message({
            type: 'success',
            message: '操作成功!'
          });
        }).catch(() => {
          this.loading = false;
        });
      });
    },
    // 取消管理员
    handleCancelAdmin(user) {
      this.$confirm('确定将此成员取消管理员吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        this.loading = true;
        cancelAdmin({
          id: user.id
        }).then((response) => {
          this.loading = false;
          this.getList();
          this.$message({
            type: 'success',
            message: '操作成功!'
          });
        }).catch(() => {
          this.loading = false;
        });
      });
    },
    // 删除成员
    handleDelete(user) {
      this.$confirm('确定要删除此成员吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        this.loading = true;
        deleteUser({
          id: user.id
        }).then((response) => {
          this.loading = false;
          this.getList();
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        }).catch(() => {
          this.loading = false;
        });
      });
    },
    // 查询
    handleFilter() {
      this.listQuery.page = 1;
      this.list = []
      this.total = 0
      this.$nextTick(() => {
        this.$refs.myTable.doLayout(); // 在DOM更新后执行
      });
      this.getList();
    },
    // 更改每页行数
    handleSizeChange(val) {
      this.listQuery.pagesize = val;
      this.getList();
    },
    // 更改页码
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    // 去还款
    handleRepayment(order) {
      this.checkList.push(order.id)
      this.handleMultiRepayment()
    },
    //批量还款
    handleMultiRepayment() {
      if (this.checkList.length == 0) {
        this.$message({
          type: 'warning',
          message: '请选择还款订单'
        });
        return false;
      }
      this.$router.push({
        path: '/repayment/team',
        query: {
          id: this.checkList.join(','),
        }
      });
    },
    // 查看详情
    handleDetail(order) {
      this.$router.push({
        path: '/team/order/detail',
        query: {
          id: order.id
        }
      });
    },
  }
};
</script>

<style lang="scss" scoped>
.my-property-component {
  width: 100%;
  margin-top: 16px;

  .property-info-wrap {
    width: 100%;
    padding: 32px 50px;
    box-sizing: border-box;
    background: #FFFFFF;
    box-shadow: 0px 0px 10px 1px rgba(111, 127, 132, 0.102);
    border-radius: 2px;
    display: grid;
    grid-template-columns: 352px auto;

    .balance-info {
      width: 100%;

      .title {
        font-size: 16px;
        font-weight: 400;
        color: #6F7F84;
        margin-bottom: 10px;
      }

      .balance-num {
        font-size: 20px;
        font-weight: 400;
        color: #FABE2A;
        margin-bottom: 18px;
      }

      .btn-list {
        display: flex;
        align-items: center;
        column-gap: 13px;

        .btn {
          width: 81px;
          height: 39px;
          border-radius: 0;
          border: 1px solid #A0A9AC;
          font-size: 16px;
          font-weight: 400;
          color: #A0A9AC;
        }
      }
    }

    .credit-deposit {
      width: 100%;
      padding-left: 59px;
      border-left: 1px solid #CCD7DB;

      .title {
        color: #222222;
      }
    }
  }

  .order-card {
    width: 100%;
    margin-top: 16px;
    background: #FFFFFF;
    box-shadow: 0px 0px 10px 1px rgba(111, 127, 132, 0.102);
    border-radius: 2px;
    padding-bottom: 20px;

    .order-tab {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #CCD7DB;
      padding: 19px 25px 0 25px;
      box-sizing: border-box;

      .tabs {
        display: flex;
        align-items: center;
        column-gap: 60px;
        width: 100%;

        .item {
          font-size: 16px;
          font-weight: 400;
          color: #222222;
          padding-bottom: 11px;
          cursor: pointer;

          .num {
            color: #00B4E8 !important;
            margin-left: 5px;
          }
        }

        .active {
          color: #00B4E8 !important;
          border-bottom: 2px solid #00B4E8 !important;
        }
      }


    }


    .table-wrap {
      width: 100%;
      display: flex;
      flex-direction: column;
      row-gap: 20px;
      // align-items: center;
      padding: 29px 24px 20px 24px;
      box-sizing: border-box;

      .el-button--text {
        padding: 0;
        margin-left: 0;
      }

      .table {
        border: 1px solid #DCE5EB;
      }

      th {
        text-align: center;
        padding: 13px 0;
      }

      thead {
        tr {
          th {
            background-color: #E9F3F6;
          }

          th:nth-child(1) {
            font-size: 16px;
            font-weight: 400;
            color: #222222;

            i {
              color: #6F7F84;
            }
          }

          th:nth-child(2),
          th:nth-child(3),
          th:nth-child(4) {
            width: 120px;
          }

          th:nth-child(5) {
            width: 170px;
          }
        }
      }

      tbody {
        .name-th {
          width: 100%;
          display: flex;
          align-items: center;
          column-gap: 10px;
          padding-left: 30px;
          box-sizing: border-box;

          &>img {
            width: 75px;
            height: 75px;
          }
        }

        .pay-btn {
          width: 90px;
          height: 30px;
          background: #00B4E8;
          border-radius: 15px;
          font-size: 16px;
          font-weight: 400;
          color: #FFFFFF;
          margin: 0 auto;
        }

        tr {
          th {
            p {
              margin: 5px 0;
              cursor: pointer;
            }
          }
        }

        th:not(:last-child) {
          border-right: 1px solid #DCE5EB;
        }

        tr:not(:last-child) {
          border-bottom: 1px solid #DCE5EB;
        }

        &>.empty {
          position: relative;
          height: 43px;

          &>th {
            position: absolute;
            width: 100%;
            height: 43px;
            font-size: 15px;
            color: #999999;
          }
        }
      }
    }
  }
}
</style>
